import { CamposCustom } from './CamposCustom';
import React, { useState } from 'react';
import { DateBadge } from '../../components/base';

import { LEAD_ORIGINS, SERVICE_TYPES, STAGES } from '../../lib/constantes';
import { getDateStatus, getRecMonths, normalizeInstagram, normalizeUrl } from '../../lib/formato';

function LeadForm({ lead, partners, sellers, company, leads: existingLeads, camposCustom = [], vendedorPadrao = null, onSave, onCancel }) {
  const blank = { company_name:'', contact_name:'', contact_email:'', contact_phone:'',
                  stage:'backlog', value:'', notes:'', next_contact_date:'', loss_reason:'', repescar_em:'',
                  site:'', instagram:'',
                  p1_id:'', p1_commission:'', p1_consultant_id:'',
                  p2_id:'', p2_commission:'', p2_consultant_id:'',
                  seller_id:'', service_type:'', recurrence:'', variable_rate:'', origem:'',
                  proposal_url:'', forecast_date:'', forecast_prob:'', followup_days:'' };
  const [f, setF] = useState(() => {
    // Lead novo já nasce com o responsável padrão da empresa, e dá para trocar.
    // Só na criação: editar lead antigo não pode ganhar vendedor do nada.
    if (!lead) return vendedorPadrao ? { ...blank, seller_id: vendedorPadrao.id } : blank;
    const [p1,p2] = lead.partners||[];
    return { ...blank, ...lead, value:lead.value??'',
             p1_id:p1?.id||'', p1_commission:p1?.commission_rate||'', p1_consultant_id:p1?.consultant_id||'',
             p2_id:p2?.id||'', p2_commission:p2?.commission_rate||'', p2_consultant_id:p2?.consultant_id||'',
             seller_id:lead.seller_id||'', service_type:lead.service_type||'',
             recurrence:lead.recurrence||'', variable_rate:lead.variable_rate??'',
             proposal_url:lead.proposal_url||'',
             forecast_date:lead.forecast_date||'', forecast_prob:lead.forecast_prob??'',
             followup_days: lead.followup_days ?? '' };
  });
  const set = (k,v) => setF(p=>({...p,[k]:v}));
  const [custom, setCustom] = useState(() => ({ ...(lead?.custom || {}) }));
  const ds = f.next_contact_date ? getDateStatus(f.next_contact_date) : null;

  const handleSubmit = e => {
    e.preventDefault();
    const partnersList = [];
    if (f.p1_id) {
      const p=partners.find(x=>x.id===f.p1_id);
      if(p) {
        const cons = p.consultants?.find(c=>c.id===f.p1_consultant_id);
        partnersList.push({id:p.id,name:p.name,commission_rate:Number(f.p1_commission)||0,
          consultant_id:cons?.id||'', consultant_name:cons?.name||''});
      }
    }
    if (f.p2_id && f.p2_id!==f.p1_id) {
      const p=partners.find(x=>x.id===f.p2_id);
      if(p) {
        const cons = p.consultants?.find(c=>c.id===f.p2_consultant_id);
        partnersList.push({id:p.id,name:p.name,commission_rate:Number(f.p2_commission)||0,
          consultant_id:cons?.id||'', consultant_name:cons?.name||''});
      }
    }
    const sellerObj = sellers?.find(s=>s.id===f.seller_id);
    onSave({ company_name:f.company_name, contact_name:f.contact_name, contact_email:f.contact_email,
             contact_phone:f.contact_phone, stage:f.stage, value:Number(f.value)||0,
             // guardados já normalizados: o site com protocolo e o Instagram como @ puro
             site: normalizeUrl(f.site), instagram: normalizeInstagram(f.instagram),
             notes:f.notes, next_contact_date:f.next_contact_date||null, partners:partnersList,
             loss_reason: ['perdido','repescagem'].includes(f.stage) ? (f.loss_reason||'') : '',
             repescar_em: f.stage==='perdido' ? (f.repescar_em||null) : null,
             seller_id: f.seller_id||null, seller_name: sellerObj?.name||'',
             service_type: company==='maximizy' ? (f.service_type||null) : null,
             recurrence: f.recurrence||null,
             variable_rate: company==='maximizy' ? (Number(f.variable_rate)||0) : 0,
             origem: f.origem||null,
             proposal_url: normalizeUrl(f.proposal_url),
             forecast_date: f.forecast_date || null,
             forecast_prob: f.forecast_prob === '' ? null : Number(f.forecast_prob),
             followup_days: (f.followup_days === '' || f.followup_days == null) ? null : Number(f.followup_days),
             custom });
  };

  const inp = "apple-input w-full px-3 py-2 text-sm";
  const duplicate = f.company_name.trim().length > 2
    ? existingLeads?.find(l => l.id !== lead?.id && l.company_name?.toLowerCase().trim() === f.company_name.toLowerCase().trim())
    : null;

  return <form onSubmit={handleSubmit} className="space-y-3">
    <input required className={inp} placeholder="Empresa *" value={f.company_name} onChange={e=>set('company_name',e.target.value)} />
    {duplicate && <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2.5 text-xs text-amber-800">
      <span className="text-base flex-shrink-0">⚠️</span>
      <div>
        <span className="font-semibold">Possível duplicata:</span> já existe um lead "<strong>{duplicate.company_name}</strong>" nesta empresa
        ({STAGES.find(s=>s.key===duplicate.stage)?.label || duplicate.stage}).
        <span className="text-amber-600"> Verifique antes de salvar.</span>
      </div>
    </div>}
    <div className="grid grid-cols-2 gap-2">
      <input className={inp} placeholder="Contato" value={f.contact_name} onChange={e=>set('contact_name',e.target.value)} />
      <input className={inp} placeholder="Telefone" value={f.contact_phone} onChange={e=>set('contact_phone',e.target.value)} />
    </div>
    <input className={inp} placeholder="E-mail" type="email" value={f.contact_email} onChange={e=>set('contact_email',e.target.value)} />
    <div className="grid grid-cols-2 gap-2">
      <input className={inp} placeholder="Site (suaempresa.com.br)" value={f.site||''} onChange={e=>set('site',e.target.value)} />
      <input className={inp} placeholder="Instagram (@perfil)" value={f.instagram||''} onChange={e=>set('instagram',e.target.value)} />
    </div>
    <div className="grid grid-cols-2 gap-2">
      <select className={inp} value={f.stage} onChange={e=>set('stage',e.target.value)}>
        {STAGES.map(s=><option key={s.key} value={s.key}>{s.label}</option>)}
      </select>
      <input className={inp} placeholder="Valor mensal (R$)" type="number" min="0" step="0.01" value={f.value} onChange={e=>set('value',e.target.value)} />
    </div>
    <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">📍 Origem do Lead</label>
      <select className={inp} value={f.origem} onChange={e=>set('origem',e.target.value)}>
        <option value="">— Selecione —</option>
        {LEAD_ORIGINS.map(o=><option key={o.key} value={o.key}>{o.emoji} {o.label}</option>)}
      </select>
    </div>
    <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">📄 Link da Proposta</label>
      <div className="flex items-center gap-2">
        <input className={inp} type="url" inputMode="url" placeholder="propostas.maximizy.com.br/cliente"
          value={f.proposal_url} onChange={e=>set('proposal_url',e.target.value)} />
        {normalizeUrl(f.proposal_url) && <a
          href={normalizeUrl(f.proposal_url)} target="_blank" rel="noopener noreferrer"
          aria-label="Abrir proposta em nova guia" title="Abrir proposta"
          className="tap-safe flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-xl bg-indigo-50 text-indigo-600 hover:bg-indigo-100 transition-colors">
          ↗
        </a>}
      </div>
      <p className="t-caption-2 text-gray-400 mt-1">Pode colar sem o https, completamos sozinho.</p>
    </div>
    {company==='maximizy' && <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">📊 % Variável sobre Faturamento</label>
      <div className="flex items-center gap-2">
        <input className={inp} placeholder="Ex: 2.5" type="number" min="0" max="100" step="0.01"
          value={f.variable_rate} onChange={e=>set('variable_rate',e.target.value)} />
        <span className="text-sm text-gray-400 font-medium flex-shrink-0">% do fat.</span>
      </div>
      <p className="t-caption-2 text-gray-400 mt-1">Além do valor fixo mensal, será cobrado esse % sobre o faturamento do cliente.</p>
    </div>}
    {['perdido','repescagem'].includes(f.stage) && <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">🔴 Motivo da Perda</label>
      <select className={inp} value={f.loss_reason} onChange={e=>set('loss_reason',e.target.value)}>
        <option value="">— Selecione —</option>
        <option value="sem_resposta">Cliente não respondeu mais</option>
        <option value="preco">Preço</option>
        <option value="concorrente">Fechou com concorrente</option>
        <option value="atendimento_ineficiente">Atendimento ineficiente</option>
        <option value="outros">Outros</option>
      </select>
      {f.stage==='repescagem' && <p className="t-caption-2 text-gray-400 mt-1">
        Guardado de quando o lead foi perdido. É o contexto para a retomada.
      </p>}
    </div>}
    {f.stage==='perdido' && <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">🔄 Repescar em</label>
      <div className="flex items-center gap-2">
        <input className={inp} type="date" value={f.repescar_em||''}
          onChange={e=>set('repescar_em',e.target.value)} />
        {f.repescar_em && <DateBadge dateStr={f.repescar_em} />}
      </div>
      <p className="t-caption-2 text-gray-400 mt-1">
        Nessa data o lead volta sozinho para a coluna Repescagem e entra no sino. Deixe vazio para não repescar.
      </p>
    </div>}
    <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">🎯 Previsão de Fechamento</label>
      <div className="grid grid-cols-2 gap-2">
        <input className={inp} type="date" value={f.forecast_date||''}
          onChange={e=>set('forecast_date',e.target.value)} />
        <select className={inp} value={f.forecast_prob} onChange={e=>set('forecast_prob',e.target.value)}>
          <option value="">— Probabilidade —</option>
          <option value="90">90% · quase certo</option>
          <option value="70">70% · provável</option>
          <option value="50">50% · em aberto</option>
          <option value="30">30% · difícil</option>
          <option value="10">10% · improvável</option>
        </select>
      </div>
      <p className="t-caption-2 text-gray-400 mt-1">Usado no pipeline ponderado dos KPIs.</p>
    </div>
    <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">Próxima Abordagem</label>
      <div className="flex items-center gap-2">
        <input className={inp} type="date" value={f.next_contact_date||''} onChange={e=>set('next_contact_date',e.target.value)}
          required={f.stage==='repescagem'} title={f.stage==='repescagem' ? 'Em Repescagem a data é obrigatória: é ela que faz o lead piscar e notificar' : undefined} />
        {ds && <DateBadge dateStr={f.next_contact_date} />}
        <select className={inp} value={f.followup_days ?? ''} onChange={e=>set('followup_days',e.target.value)}
          aria-label="Repetir a cada" title="Follow-up recorrente: reagenda sozinho a cada contato feito">
          <option value="">Não repetir</option>
          <option value="3">🔁 a cada 3 dias</option>
          <option value="7">🔁 a cada 7 dias</option>
          <option value="15">🔁 a cada 15 dias</option>
          <option value="30">🔁 a cada 30 dias</option>
        </select>
      </div>
    </div>
    <CamposCustom campos={camposCustom} valores={custom} onChange={setCustom} />
    {[1,2].map(n => {
      const idKey=`p${n}_id`, cmKey=`p${n}_commission`, consKey=`p${n}_consultant_id`;
      const opts = n===2 ? partners.filter(p=>p.id!==f.p1_id) : partners;
      const selPartner = partners.find(p=>p.id===f[idKey]);
      const hasConsultants = selPartner?.consultants?.length > 0;
      return <div key={n} className="space-y-2">
        <div className="grid grid-cols-3 gap-2 items-end">
          <div className="col-span-2">
            <label className="text-xs text-gray-500 font-medium mb-1 block">Parceiro {n}</label>
            <select className={inp} value={f[idKey]} onChange={e=>{
              const pid = e.target.value;
              set(idKey, pid);
              set(consKey, ''); // reset consultor ao trocar parceiro
              if (pid && !f[cmKey]) {
                const p = partners.find(x=>x.id===pid);
                if (p?.default_commission) set(cmKey, p.default_commission);
              }
            }}>
              <option value="">— Nenhum —</option>
              {opts.map(p=><option key={p.id} value={p.id}>{p.name}{p.default_commission>0?` (${p.default_commission}% padrão)`:''}</option>)}
            </select>
          </div>
          {f[idKey] && <div>
            <label className="text-xs text-gray-500 font-medium mb-1 block">Comissão %</label>
            <input className={inp} type="number" min="0" max="100" step="0.1" placeholder="%" value={f[cmKey]} onChange={e=>set(cmKey,e.target.value)} />
          </div>}
        </div>
        {hasConsultants && f[idKey] && <div>
          <label className="text-xs text-gray-500 font-medium mb-1 block">
            👤 Consultor de {selPartner.name}
          </label>
          <select className={inp} value={f[consKey]} onChange={e=>{
            const cid = e.target.value;
            set(consKey, cid);
            // Auto-preenche comissão com o valor padrão dos consultores do parceiro
            if (cid && selPartner.consultants_commission) {
              set(cmKey, selPartner.consultants_commission);
            }
          }}>
            <option value="">— Nenhum —</option>
            {selPartner.consultants.map(c=><option key={c.id} value={c.id}>{c.name}{c.email?` · ${c.email}`:''}</option>)}
          </select>
          {selPartner.consultants_commission > 0 && <p className="t-caption-2 text-gray-400 mt-1">
            ⚡ Comissão padrão: {selPartner.consultants_commission}% (preenchida automaticamente)
          </p>}
        </div>}
      </div>;
    })}
    {sellers?.length>0 && <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">👤 Vendedor responsável</label>
      <select className={inp} value={f.seller_id} onChange={e=>set('seller_id',e.target.value)}>
        <option value="">— Nenhum —</option>
        {sellers.map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
    </div>}
    {company==='maximizy' && <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">🎯 Tipo de Serviço</label>
      <select className={inp} value={f.service_type} onChange={e=>set('service_type',e.target.value)}>
        <option value="">— Selecione —</option>
        {SERVICE_TYPES.map(s=><option key={s} value={s}>{s}</option>)}
      </select>
    </div>}
    <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">🔁 Recorrência do Contrato</label>
      <div className="flex gap-2 mb-2">
        <button type="button"
          onClick={()=>set('recurrence','unica')}
          className={`flex-1 py-2 text-sm rounded-xl border font-medium transition-all ${f.recurrence==='unica'?'bg-gray-800 text-white border-transparent':'bg-gray-50 text-gray-600 border-gray-200 hover:border-gray-300'}`}>
          Execução única
        </button>
        <button type="button"
          onClick={()=>{ if(!f.recurrence||f.recurrence==='unica') set('recurrence','6'); }}
          className={`flex-1 py-2 text-sm rounded-xl border font-medium transition-all ${f.recurrence&&f.recurrence!=='unica'?'bg-gray-800 text-white border-transparent':'bg-gray-50 text-gray-600 border-gray-200 hover:border-gray-300'}`}>
          Mensal recorrente
        </button>
      </div>
      {f.recurrence && f.recurrence!=='unica' && <div className="space-y-2">
        <div className="flex gap-1.5 flex-wrap">
          {[1,3,6,12,18,24].map(m=>(
            <button type="button" key={m}
              onClick={()=>set('recurrence',String(m))}
              className={`px-3 py-1.5 text-xs rounded-full border font-medium transition-all ${getRecMonths(f.recurrence)===m?'bg-blue-500 text-white border-transparent':'bg-gray-50 text-gray-600 border-gray-200 hover:border-gray-300'}`}>
              {m}m
            </button>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <input className={inp} type="number" min="1" max="60" placeholder="Ou digite o nº de meses"
            value={f.recurrence&&f.recurrence!=='unica'?getRecMonths(f.recurrence):''}
            onChange={e=>{ const v=parseInt(e.target.value); if(!isNaN(v)&&v>=1) set('recurrence',String(v)); }} />
          <span className="text-sm text-gray-400 flex-shrink-0">meses</span>
        </div>
      </div>}
    </div>
    <textarea className={inp} rows={3} placeholder="Observações" value={f.notes} onChange={e=>set('notes',e.target.value)} />
    <div className="flex gap-2 pt-1">
      <button type="submit" className="flex-1 bg-blue-500 text-white rounded-full py-2 text-sm font-semibold hover:bg-blue-600">Salvar</button>
      <button type="button" onClick={onCancel} className="flex-1 bg-gray-100 text-gray-600 rounded-full py-2 text-sm font-semibold hover:bg-gray-200">Cancelar</button>
    </div>
  </form>;
}

// ─── DealBoard (Negociação / Informações Fechadas) ───────

export { LeadForm };
